import { TriangleAlertIcon } from "@/components/icons";
import { Button } from "@/components/kit";

type Props = {
  message?: string;
  onRetry: () => void;
  isRetrying?: boolean;
};

export function ReportsQueryError({
  message = "ໂຫຼດຂໍ້ມູນບໍ່ສຳເລັດ — ກະລຸນາລອງໃໝ່",
  onRetry,
  isRetrying,
}: Props) {
  return (
    <div className="brand-card flex flex-col items-center gap-3 border-destructive/25 bg-destructive/5 p-6 text-center sm:flex-row sm:text-left">
      <TriangleAlertIcon className="size-5 shrink-0 text-destructive" />
      <p className="flex-1 text-sm">{message}</p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="rounded-full"
        disabled={isRetrying}
        onClick={onRetry}
      >
        {isRetrying ? "ກຳລັງໂຫຼດ..." : "ລອງໃໝ່"}
      </Button>
    </div>
  );
}
